import React from 'react';
import { HeroSection } from '../components/sections/HeroSection';
import { LeaderboardSection } from '../components/sections/LeaderboardSection';
import { ProductTourSection } from '../components/sections/ProductTourSection';
import { PricingSection } from '../components/sections/PricingSection';
import { SocialSection } from '../components/sections/SocialSection';
import { NewsletterSection } from '../components/sections/NewsletterSection';
import {
  ProblemStorySection,
  WhatHasntWorkedSection,
  BridgeSection,
  HowItWorksSection,
  FeaturesSection,
  TransformationSection,
  FAQSection,
  UrgencySection,
} from '../components/sections/StorySections';
export const MainPage = () => {
  return (
    <main className="min-h-screen bg-jp-page text-jp-ink text-left overflow-x-hidden">
      <HeroSection />
      <ProblemStorySection />
      <WhatHasntWorkedSection />
      <BridgeSection />
      <ProductTourSection />
      <HowItWorksSection />
      <FeaturesSection />
      <LeaderboardSection />
      <TransformationSection />
      <SocialSection />
      <NewsletterSection />
      <FAQSection />
      <UrgencySection />
      <PricingSection />
    </main>
  );
};
